export enum ButtonDisplayType {
	Caption = 1,
	Icon = 2,
	IconCaption = 3
}